export const PARTS_FILTERS_MODALS_EVENT = `modals:parts:filters`;

export const SEARCH_FILTER_MODAL_EVENT = `${PARTS_FILTERS_MODALS_EVENT}:search-filter`;
export const SEARCH_FILTER_MODAL_EVENT_OPEN = `${SEARCH_FILTER_MODAL_EVENT}:open`;
export const SEARCH_FILTER_MODAL_EVENT_CLOSE = `${SEARCH_FILTER_MODAL_EVENT}:close`;
